const pixPriorityTransfeeraAPI = require('../pix/pixPriority');

const pixPriority = {
  high: 'high',
  normal: 'normal',
  convertToPayoutEngine(priority) {
    return {
      [pixPriorityTransfeeraAPI.HIGH]: this.high,
      [pixPriorityTransfeeraAPI.NORMAL]: this.normal,
      [pixPriorityTransfeeraAPI.DEFAULT]: this.high
    }[priority];
  }
};

module.exports = pixPriority;
